// src/json/servicesOverview.json
export const servicesOverviewHighRiseMidRiseProjects = {
    eyebrow: "OUR HIGH-RISE & MID-RISE",
    titleHighlight: "SERVICES INCLUDE:",
    items: [
        {
            title: "Exterior Painting & Coatings",
            description: "Durable, weather-resistant finishes that protect against UV exposure, moisture, and pollutants."
        },
        {
            title: "Building Envelope Renewal",
            description: "Comprehensive solutions including waterproofing, caulking, flashing, and insulation to extend the life of your structure."
        },
        {
            title: "Concrete & Façade Restoration",
            description: "Repairing cracks, spalling, and structural damage to ensure safety, longevity, and visual appeal."
        },
        {
            title: "Sealant & Waterproofing Solutions",
            description: "Preventing water leaks and air infiltration with high-performance sealants and moisture barriers."
        },
        {
            title: "Metal & Glass Curtain Wall Maintenance",
            description: "Restoring and protecting high-rise façade elements to maintain durability and efficiency."
        },
        {
            title: "Structural & Balcony Repairs",
            description: "Reinforcing weakened balconies, railings, and other structural components for long-term stability."
        }
    ],
    imageUrl: "/assets/imgs/services/4HighRiseMidRiseProjects/servicesOverview/fondo.png",
    button: {
        text: "Request a Quote",
        url: "/quote"
    }
};  